import { useQuery } from '@tanstack/react-query';

const useDevicesGeoPosition = () => {
  const query = useQuery<GeolocationPosition>({
    queryKey: ['position'],
    queryFn: async () =>
      new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            resolve(position);
          },
          (error) => {
            reject(error);
          },
        );
      }),
  });

  return query;
};

export default useDevicesGeoPosition;
